/**
 * imageUtils.tsx - Image URL Processing Utilities
 */

import { sublessHostname } from './formatHostname'
import { NSImage } from '@/types/common.types'

export const getImageUrl = (
  image: NSImage | string | null | undefined,
  options: {
    width?: number;
    height?: number;
    fit?: string;
    facepad?: number;
    auto?: string;
  } = {}
): string => {
  if (!image) return '';

  if (typeof image === 'string') return image;

  if (typeof image === 'object' && image.uuid) {
    const {
      width = 85,
      height = 85,
      fit = 'facearea',
      facepad = 50,
      auto = 'format'
    } = options;

    const hostname = sublessHostname();

    return `https://newssocial1.imgix.net/${hostname === "localhost" ? "newssocial.uk" : hostname}/${image.uuid}?w=${width}&h=${height}&fit=${fit}&facepad=${facepad}&auto=${auto}`;
  }

  return '';
};

export const getAvatarUrl = (image: NSImage | string | null | undefined): string => {
  return getImageUrl(image, {
    width: 85,
    height: 85,
    fit: 'facearea',
    facepad: 50,
    auto: 'format'
  });
};
